import { Text, View } from '@react-pdf/renderer'
import { IInvoiceFr } from '../../../types/invoice-fr'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

const SenderInfo = ({ invoiceData }: { invoiceData: IInvoiceFr }) => {
  const { t } = useTranslation()

  return (
    <View
      style={{
        ...styles.cardContainer,
        ...styles.partyContainer,
        marginRight: 5,
      }}
    >
      <Text style={styles.sectionHeader}>
        {t('sharedDiagnostic.invoice.fromResquesting')}
      </Text>
      <View style={styles.divider} />
      <View style={{ marginVertical: 5 }}>
        <Text style={[styles.boldText, { fontSize: 11, marginBottom: 5 }]}>
          {invoiceData.senderCompanyName}
        </Text>
        <Text style={styles.text}>
          {t('shared.common.dr')} {invoiceData.senderContactName},{' '}
          {invoiceData.senderSpecialty}
        </Text>
        <Text style={styles.text}>{invoiceData.senderEmail}</Text>
        <View style={styles.mYcontainer}>
          <View style={[styles.flexRowContainer]}>
            <Text style={styles.labelText}>
              {t('sharedDiagnostic.invoice.adeliFiness')}
            </Text>
            <Text style={styles.valueText}>
              {invoiceData.senderAdeliFinessNumber}
            </Text>
          </View>
          <View style={[styles.flexRowContainer]}>
            <Text style={styles.labelText}>
              {t('sharedDiagnostic.invoice.rpps')}
            </Text>
            <Text style={styles.valueText}>{invoiceData.senderRppsNumber}</Text>
          </View>
        </View>
      </View>
    </View>
  )
}

export default SenderInfo
